// Switch KISS — checkbox estilizado (API preservada: checked/onChange como
// input nativo — 4 chamadores em admin dependem disso). Visual re-skinnado
// pro par de cores --color-coral / --color-line do handoff (era primary/muted).
import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { className, label, ...rest },
  ref,
) {
  return (
    <label className={cn("inline-flex items-center gap-2 cursor-pointer", className)}>
      <span className="relative inline-block h-4 w-7 flex-shrink-0">
        <input
          ref={ref}
          type="checkbox"
          className="peer absolute inset-0 h-full w-full appearance-none opacity-0"
          {...rest}
        />
        <span
          aria-hidden
          className={cn(
            "absolute inset-0 rounded-full bg-line border border-line transition-colors",
            "peer-checked:bg-coral peer-checked:border-coral",
            "peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-background",
            "peer-disabled:opacity-50",
          )}
        />
        <span
          aria-hidden
          className="absolute top-0.5 left-0.5 h-3 w-3 rounded-full bg-card shadow-sm transition-transform peer-checked:translate-x-3"
        />
      </span>
      {label ? <span className="text-md text-ink">{label}</span> : null}
    </label>
  );
});
